import configSelectors from './selectors/configSelectors';
import franchiseSelectors from './selectors/franchiseSelectors';
import initialReportSelectors from './selectors/initialReportSelectors';
import reportSelectors from './selectors/reportSelectors';
import seasonSelectors from './selectors/seasonSelectors';

const getConfig = (state) => state.config;

export default {
    getConfig,
    ...initialReportSelectors,
    ...reportSelectors,
    ...seasonSelectors,
    ...franchiseSelectors,
    ...configSelectors,
};
